export const AllCampaignGroupId = -1;
